const DEFAULT_WHATSAPP_NUMBER = "916283272343";

export function getWhatsAppNumber() {
  const raw = process.env.REACT_APP_WHATSAPP_NUMBER || DEFAULT_WHATSAPP_NUMBER;
  return raw.replace(/\D/g, "");
}

/**
 * Build a pre-filled WhatsApp order message and wa.me URL.
 */
export function buildWhatsAppOrderUrl(cart, { name, email } = {}) {
  const lines = cart.items.map((it) => {
    const lineTotal = it.product.price * it.quantity;
    return `• ${it.product.name} × ${it.quantity} — ₹${lineTotal.toFixed(2)}`;
  });

  const parts = [
    "New Order — Crown & Stitch",
    "",
    ...lines,
    "",
    `Total: ₹${cart.total.toFixed(2)}`,
  ];

  if (name) parts.push("", `Customer: ${name}`);
  if (email) parts.push(`Email: ${email}`);
  parts.push("", "Please confirm availability, shipping, and payment details.");

  const text = parts.join("\n");
  return `https://wa.me/${getWhatsAppNumber()}?text=${encodeURIComponent(text)}`;
}

export function openWhatsAppOrder(cart, customer = {}) {
  const url = buildWhatsAppOrderUrl(cart, customer);
  window.open(url, "_blank", "noopener,noreferrer");
}
